import {
    Aggregate,
    AggregateColumnDirective,
    AggregateColumnsDirective,
    AggregateDirective,
    AggregatesDirective,
    ColumnChooser,
    ColumnDirective,
    ColumnMenu,
    ColumnsDirective,
    ContextMenu,
    Edit,
    EditSettingsModel,
    ExcelExport,
    Filter,
    FilterSettingsModel,
    GridComponent,
    Group,
    Inject,
    Page,
    PageSettingsModel,
    PdfExport,
    Reorder,
    Resize,
    Sort,
    Toolbar,
    ToolbarItems,
} from '@syncfusion/ej2-react-grids';
import {GetBackendUrlForGlobalFunctions, GetErpTypeFromConfig} from '../App';
import axios, {AxiosResponse, CancelTokenSource} from 'axios';
import {useEffect, useState, useRef} from 'react';
import {all_information, loadingShow} from '../App';
import Message from '../utils/Message/Message';
import './GlobalGrid.css';
import {getFethSize} from '../services/SystemSettings/SystemSettingsService';
import {
    getLocalUtcOffSetValue,
    isInlineEditOrderDataEqual,
} from '../utils/Methods/methods';
import {useDispatch, useSelector} from 'react-redux';
import {setFetchSize} from '../redux/search.slice';
import {EditWorkOrder} from '../services/CloudScheduler/CloudSchedulerServices';
import {UndoRedo} from '@syncfusion/ej2-react-gantt';
import {TooltipComponent} from "@syncfusion/ej2-react-popups";

const headers = {
    'Content-Type': 'application/json',
};

interface IProps {
    undo?: boolean;
    children?: React.ReactNode;
    query: string;
    columns: Array<any>;
    height: string;
    signalOfLoad: boolean;
    toolbarOptions?: ToolbarItems[];
    toolbarClickItems?: Function;
    add_query?: string;
    edit_query?: string;
    delete_query?: string;
    get_query?: string;
    id?: string;
    isFitInCOntent?: boolean;
    rowSelected?: Function;
    rowDeselected?: Function;
    enableAggregate?: boolean;
    aggregateColumns?: Array<any>;
    groupSettings?: Object;
    enablePagination?: boolean;
    contextMenuItems?: Array<any>;
    contextMenuClick?: (args: any) => void;
    gridRef?: (component: GridComponent) => void;
    allowCheckBox?: boolean;
    allowMultiSelection?: boolean;
    resetSignal?: string;
    noNeedPagination?: boolean;
    additionalCrudParams?: Object;
    refreshRequest?: string;
    primaryKeyName?: string;
    additinalToolbarClick?: (args: any) => void;
    queryCellInfo?: (args: any) => void;
    theEditOptions?: EditSettingsModel;
    mapFieldToType?: Array<any>;
    toolbarTemplate?: any;
    avoidWhereClause?: boolean;
    refreshRequestHandle?: () => void | undefined;
    fromComponent?: string;
    rowDataBound?: (args: any) => void;
    excelQueryCellInfo?: any;
    contextMenuOpen?: any;
}

// var model: any = [];
// var theGrid: GridComponent;
const GlobalGrid = ({
                        undo,
                        fromComponent,
                        columns,
                        query,
                        toolbarOptions,
                        height,
                        add_query,
                        delete_query,
                        edit_query,
                        get_query,
                        id,
                        isFitInCOntent,
                        rowSelected,
                        rowDeselected,
                        aggregateColumns,
                        enableAggregate,
                        groupSettings,
                        enablePagination,
                        signalOfLoad,
                        contextMenuClick,
                        contextMenuItems,
                        gridRef,
                        allowCheckBox,
                        allowMultiSelection,
                        resetSignal,
                        noNeedPagination,
                        additionalCrudParams,
                        toolbarClickItems,
                        refreshRequest,
                        primaryKeyName,
                        additinalToolbarClick,
                        queryCellInfo,
                        theEditOptions,
                        mapFieldToType,
                        toolbarTemplate,
                        avoidWhereClause,
                        refreshRequestHandle,
                        rowDataBound,
                        excelQueryCellInfo,
                        contextMenuOpen
                    }: IProps) => {
    const modelRef = useRef<any[]>([]);
    const global_fetch_size = useSelector(
        (state: any) => state.search.page_range_from_settings
    );
    const theGridRef = useRef<GridComponent | null>(null);
    const isAddRef = useRef(false);
    const isRenderFinishRef = useRef(false);
    const current_page_ref = useRef(Math.floor(global_fetch_size / 50));
    const current_page_range_ref = useRef(`1$${global_fetch_size}`);
    const thePrimaryFieldNameRef = useRef('id');
    let timezone_offset = useSelector(
        (state: any) => state.search.timezone_offset
    );
    let isAppliedEventPlan = useSelector(
        (state: any) => state.search.isAppliedEventPlan
    );
    let thePlanID = Number(localStorage.getItem('cs_plan_dd_value'));
    const ERP_TYPE = GetErpTypeFromConfig();
    const dispatch = useDispatch();
    const requestIdRef = useRef(0);
    const cancelTokenSourceRef = useRef<CancelTokenSource | null>(null);
    const [datasource, setDatasource] = useState<any>();
    const FilterOptions: FilterSettingsModel = {type: 'Excel'};
    const tz: string = Intl.DateTimeFormat().resolvedOptions().timeZone;
    const [timezoneName, setTimezoneName] = useState<string>(tz);
    let InlineEditedList: any[] = [];
    const server_gmt = useSelector((state: any) => state.search.server_gmt)
    const serverOffsetMillis = 60 * 1000 * -(server_gmt * 60);
    const localOffset = new Date().getTimezoneOffset();
    const localOffsetMillis = 60 * 1000 * localOffset;

    let page_range_from_settings = global_fetch_size;
    var current_page: number = page_range_from_settings / 50;

    var moment = require('moment-timezone');
    const [renderamount, setrenderamount] = useState(0);
    const editOptions: EditSettingsModel = {
        allowAdding: true,
        allowDeleting: true,
        allowEditing: true,
        showDeleteConfirmDialog: true,
    };
    const pageOptions: PageSettingsModel = {
        currentPage: 1,
        pageSize: 50,
        pageCount: 8,
        pageSizes: false,
    };
    const toolbarClick = (args: any) => {
        if (additinalToolbarClick) {
            additinalToolbarClick(args);
        }
        if (args.item.id === 'refresh' && !additinalToolbarClick) {
            modelRef.current = [];
            isRenderFinishRef.current = true;
            current_page_range_ref.current = `1$${global_fetch_size}`;
            current_page_ref.current = Math.floor(global_fetch_size / 50);
            getData(query, modelRef.current, theGridRef.current!);
            theGridRef.current?.refresh();
        }
        if (args.item.id === id + '_excelexport') {
            theGridRef.current?.excelExport();
        }
        if (args.item.id === id + '_pdfexport') {
            theGridRef.current?.pdfExport();
        }
    };
    const actionComplete = (args: any) => {
        if (args.requestType == 'batchsave') {
            if (ERP_TYPE === 'MEX') {
                const differenceOffsetMillis = serverOffsetMillis - localOffsetMillis;

                InlineEditedList.map((item: any) => {
                    item.scheduled_start_date = new Date(
                        new Date(item.scheduled_start_date)?.getTime() +
                        differenceOffsetMillis
                    ).toString();
                    item.scheduled_end_date = new Date(
                        new Date(item.scheduled_end_date)?.getTime() +
                        differenceOffsetMillis
                    ).toString();
                });
            }
            try {
                EditWorkOrder(InlineEditedList,timezone_offset, true).then(() => {
                    Message.success('Edited');
                });
            } catch (error) {
                console.log(error);
            }
        }
    };
    const actionBegin = (args: any) => {
        if (args.action === 'add') {
            isAddRef.current = true;
            if (add_query) {
                args.data.crud_type = 'add';
                if (fromComponent === 'operation-template-detail') {
                    delete args.data.crud_type;
                    args.data.ID = thePlanID;
                }
                addPoint(args.data);
            }
        } else if (args.action === 'edit') {
            if (args.data.est_hours && args.data.required) {
                args.data.duration = (
                    parseFloat(args.data.est_hours) / parseFloat(args.data.required)
                )
                    .toFixed(2)
                    .toString();
            }
            isAddRef.current = false;
            if (edit_query) {
                if (
                    !isInlineEditOrderDataEqual(args.data, args.previousData) ||
                    id === 'operation-template-detail'
                ) {
                    delete args.data.materialStatus;
                    addPoint(args.data);
                }
            }
        } else if (args.requestType === 'delete') {
            var theKeyName = theGridRef.current!.getPrimaryKeyFieldNames();
            let rowId = args.data[0][`${theKeyName[0]}`];
            if (!rowId) {
                if (!primaryKeyName) {
                    Message.error('Primary key not found to procced');
                    return;
                } else {
                    rowId = args.data[0][`${primaryKeyName}`];
                    thePrimaryFieldNameRef.current = primaryKeyName;
                }
            } else {
                thePrimaryFieldNameRef.current = theKeyName[0];
            }
            if (delete_query) {
                args.data.crud_type = 'delete';
                deletePoint(rowId);
            }
        }
        if (args.requestType === 'paging') {
            var pS: any;
            if (args.currentPage > args.previousPage) {
                if (args.currentPage >= current_page_ref.current) {
                    current_page_ref.current++;
                    pS = theGridRef.current!.pageSettings.pageSize;
                    var start_index = (current_page_ref.current - 1) * Number(pS) + 1;
                    var end_index = start_index + (Number(pS) - 1);
                    current_page_range_ref.current = start_index + '$' + end_index;
                    getData(query, modelRef.current, theGridRef.current!);
                }
            } else if (args.currentPage === args.previousPage) {
                pS = theGridRef.current!.pageSettings.pageSize;
                var last_page = modelRef.current.length / Number(pS);
                current_page_ref.current = last_page;
            }
        }
    };
    const deletePoint = (idToDelete: string) => {
        const obj = {
            [thePrimaryFieldNameRef.current]: idToDelete,
        };
        let theUrl = GetBackendUrlForGlobalFunctions() + `${delete_query}`;
        axios
            .put(theUrl, obj, {
                headers,
            })
            .then((res) => {
                loadingShow(false);
                Message.success('Successfully');
                modelRef.current = [];
                getData(query, modelRef.current, theGridRef.current!);
            })
            .catch((err) => {
                loadingShow(false);
                if (err.response) {
                    Message.error(
                        err.response.data +
                        '\n' +
                        err.response.status +
                        '\n' +
                        err.response.headers
                    );
                } else if (err.request) {
                    Message.error(err.request);
                } else {
                    Message.error('Error: ' + err.message);
                }
            });
    };

    function extractNumberFromString(s: string): number {
        let matches: RegExpMatchArray | null = s.match(/\d+/g);
        return matches ? Number(matches.join('')) : NaN;
    }

    const getData = async (query: string, theModel: any[], grid: GridComponent) => {
        if (cancelTokenSourceRef.current) {
            cancelTokenSourceRef.current.cancel('Operation canceled by a new request.');
        }

        cancelTokenSourceRef.current = axios.CancelToken.source();

        requestIdRef.current += 1;
        const myRequestId = requestIdRef.current;

        grid?.showSpinner();

        let theQuery = '';

        if (!noNeedPagination) {
            theQuery = current_page_range_ref.current + '$' + query.trim();
        } else {
            theQuery = query.trim();
        }

        let theUrl = '';
        let theResult: AxiosResponse<any>;

        try {
            if (get_query === 'order') {
                theUrl = GetBackendUrlForGlobalFunctions() + `${get_query}/${timezone_offset}`;

                theResult = await axios.post(
                    theUrl,
                    {
                        where: theQuery,
                        avoidWhereClause,
                        noNeedPagination,
                        get_query,
                        timezone_offset,
                    },
                    {
                        cancelToken: cancelTokenSourceRef.current.token,
                    }
                );
            } else {
                if (get_query === 'mex-order') {
                    theQuery = '/changes';
                    theUrl = GetBackendUrlForGlobalFunctions() + `${get_query}` + theQuery;
                } else {
                    if (avoidWhereClause) {
                        theUrl = GetBackendUrlForGlobalFunctions() + `${get_query}?` + theQuery;
                    } else {
                        theUrl = GetBackendUrlForGlobalFunctions() + `${get_query}?where=` + theQuery;
                    }
                }

                theResult = await axios.get(theUrl, {
                    cancelToken: cancelTokenSourceRef.current.token,
                });
            }

            if (myRequestId !== requestIdRef.current) {
                loadingShow(false);
                grid?.hideSpinner();
                return;
            }

            if (isRenderFinishRef.current) {
                const targetPlanId = extractNumberFromString(query);
                const isOrderQuery =
                    get_query === 'order' || get_query === 'mex-order';

                const fastFormatDate = (dateStr: any) => {
                    if (!dateStr) return null;

                    if (typeof dateStr === 'string') {
                        if (dateStr.length >= 19 && dateStr[10] === 'T') {
                            return (
                                dateStr.substring(0, 10) +
                                ' ' +
                                dateStr.substring(11, 19)
                            );
                        }

                        if (dateStr.length === 19 && dateStr[10] === ' ') {
                            return dateStr;
                        }
                    }

                    return moment.utc(dateStr).format('YYYY-MM-DD HH:mm:ss');
                };

                theResult.data.forEach((res: any) => {
                    if (isOrderQuery) {
                        res.scheduled_start_date = fastFormatDate(
                            res.scheduled_start_date
                        );

                        res.scheduled_end_date = fastFormatDate(
                            res.scheduled_end_date
                        );

                        res.planned_start_date = fastFormatDate(
                            res.planned_start_date
                        );

                        res.planned_end_date = fastFormatDate(
                            res.planned_end_date
                        );

                        res.actual_start_date = fastFormatDate(
                            res.actual_start_date
                        );

                        res.actual_end_date = fastFormatDate(
                            res.actual_end_date
                        );

                        if (get_query === 'order') {
                            const start = res.scheduled_start_date
                                ? new Date(res.scheduled_start_date)
                                : null;

                            const end = res.scheduled_end_date
                                ? new Date(res.scheduled_end_date)
                                : null;

                            res.duration =
                                !start ||
                                !end ||
                                isNaN(start.getTime()) ||
                                isNaN(end.getTime())
                                    ? 0
                                    : (end.getTime() - start.getTime()) /
                                    (1000 * 3600);
                        }
                    }

                    for (const f_name of Object.keys(res)) {
                        if (
                            isOrderQuery &&
                            f_name === 'plan_id' &&
                            res.plan_id === targetPlanId
                        ) {
                            res.isChecked = true;
                        }

                        if (
                            f_name === 'actual_start_date' &&
                            res.actual_start_date === null
                        ) {
                            delete res.actual_start_date;
                        }

                        if (
                            f_name === 'actual_end_date' &&
                            res.actual_end_date === null
                        ) {
                            delete res.actual_end_date;
                        }

                        if (typeof res[f_name] === 'string') {
                            res[f_name] = res[f_name].trim();
                        }
                    }

                    if (Array.isArray(res.event_plans)) {
                        res.event_plans_str = res.event_plans
                            .map((ep: any) => {
                                const plansPart =
                                    ep.plans?.length > 0
                                        ? ` [${ep.plans.join(', ')}]`
                                        : '';

                                return `${ep.event_name}${plansPart}`;
                            })
                            .join(', ');
                    }

                    theModel.push(res);
                });

                if (grid) {
                    grid.dataSource = [...theModel];
                }
            }
        } catch (error) {
            if (axios.isCancel(error)) {
                return;
            }

            Message.error('Error while fetching data');
        }

        loadingShow(false);
        grid?.hideSpinner();
    };

    const addPoint = async (objCommer: any) => {
        loadingShow(true, 'Adding');
        if (objCommer.id === undefined && objCommer.id === null) {
            objCommer.id = 0;
        }
        let theMappings: any = {};
        if (mapFieldToType) {
            mapFieldToType.map((el) => {
                if (objCommer[el.field]) {
                    if (el.type === 'string') {
                        theMappings[el.field] = objCommer[el.field].toString();
                    }
                    if (el.type === 'number') {
                        theMappings[el.field] = Number(objCommer[el.field]);
                    }
                }
            });
        }
        const obj = {
            ...objCommer,
            app: 'UWORK',
            created_by: all_information.user_id,
            organization_id: all_information.company_id?.toString(),
            ...additionalCrudParams,
            ...theMappings,
        };
        delete obj.creation_date;
        delete obj.rowstamp;
        if (isAddRef.current) {
            let theUrl = GetBackendUrlForGlobalFunctions() + `${add_query}`;
            delete obj.id;
            axios
                .put(theUrl, obj, {
                    headers,
                })
                .then((res) => {
                    loadingShow(false);
                    Message.success('Successfully');
                    modelRef.current = [];
                    getData(query, modelRef.current, theGridRef.current!);
                })
                .catch((err) => {
                    loadingShow(false);
                    if (err.response) {
                        Message.error(err.response.data);
                        Message.error(err.response.status);
                        Message.error(err.response.headers);
                    } else if (err.request) {
                        Message.error(err.request);
                    } else {
                        Message.error('Error: ' + err.message);
                    }
                });
        } else {
            if (ERP_TYPE !== 'MEX') {
                timezone_offset = 0;
            }
            let theUrl =
                GetBackendUrlForGlobalFunctions() +
                `${edit_query}` +
                `/${timezone_offset}`;

            if (id === 'operation-template-detail') {
                theUrl = GetBackendUrlForGlobalFunctions() + `${edit_query}`;
            }
            if (ERP_TYPE === 'MEX') {
                const differenceOffsetMillis = serverOffsetMillis - localOffsetMillis;
                obj.scheduled_start_date = new Date(
                    new Date(obj.scheduled_start_date)?.getTime() + differenceOffsetMillis
                ).toString();
                obj.scheduled_end_date = new Date(
                    new Date(obj.scheduled_end_date)?.getTime() + differenceOffsetMillis
                ).toString();
            }
            axios
                .put(theUrl, obj, {
                    headers,
                })
                .then((res) => {
                    loadingShow(false);
                    Message.success('Successfully');
                    modelRef.current = [];
                    getData(query, modelRef.current, theGridRef.current!);
                })
                .catch((err) => {
                    loadingShow(false);
                    if (err.response) {
                        Message.error(err.response.data);
                        Message.error(err.response.status);
                        Message.error(err.response.headers);
                    } else if (err.request) {
                        Message.error(err.request);
                    } else {
                        Message.error('Error: ' + err.message);
                    }
                });
        }
    };
    const onGridCreated = () => {
        if (gridRef) {
            gridRef(theGridRef.current!);
        }
    };

    useEffect(() => {
        const getFetchSize = async () => {
            const model = await getFethSize();

            model.data.map((item: any) => {
                if (item.isChecked === true) {
                    page_range_from_settings = item.fetch_size;
                }
            });
            dispatch(setFetchSize(page_range_from_settings));
            current_page_range_ref.current = '1$' + page_range_from_settings?.toString();
            current_page_ref.current = Math.floor(page_range_from_settings / 50);
            return;
        };
        getFetchSize();
    }, [global_fetch_size]);

    useEffect(() => {
        if (modelRef.current.length > 0 && theGridRef.current) {
            theGridRef.current.dataSource = [];
        }
    }, [resetSignal]);

    useEffect(() => {
        if (
            refreshRequest &&
            refreshRequest !== '' &&
            refreshRequest?.trim() !== 'false'
        ) {
            current_page_range_ref.current = 1 + '$' + global_fetch_size;
            current_page_ref.current = Math.floor(global_fetch_size / 50);
            if (signalOfLoad) {
                modelRef.current = [];
                const getTheData = async () => {
                    await getData(query, modelRef.current, theGridRef.current!);
                    signalOfLoad = false;
                    refreshRequest = 'false';
                    if (refreshRequestHandle) {
                        refreshRequestHandle();
                    }
                };
                getTheData();
            }
        }
    }, [refreshRequest]);

    useEffect(() => {
        isRenderFinishRef.current = true;
        if (get_query) {
            modelRef.current = [];
            current_page_ref.current = Math.floor(global_fetch_size / 50);
            current_page_range_ref.current = 1 + '$' + global_fetch_size;
            if (signalOfLoad) {
                const getTheData = async () => {
                    await getData(query, modelRef.current, theGridRef.current!);
                };
                getTheData();
            }
        }
        return () => {
            isRenderFinishRef.current = false;
        };
    }, [query]);
    const undoRedoActions: any = [
        'Sorting',
        'Add',
        'ColumnReorder',
        'ColumnResize',
        'ColumnState',
        'Delete',
        'Edit',
        'Filtering',
        'Indent',
        'Outdent',
        'NextTimeSpan',
        'PreviousTimeSpan',
        'RowDragAndDrop',
        'Search',
    ];
    return (
        <div className={id}>
            <GridComponent
                actionComplete={actionComplete.bind(this)}
                rowDataBound={rowDataBound}
                cellSaved={(args) => {
                    if (!(args.value == args.previousValue)) {
                        let data = args.rowData;
                        data[args.column.field] = args.value;
                        InlineEditedList.push(data);
                    }
                }}
                id={id + '-grid'}
                ref={(refGrid: GridComponent) => {
                    theGridRef.current = refGrid;
                }}
                editSettings={theEditOptions ? theEditOptions : editOptions}
                toolbar={signalOfLoad ? toolbarOptions : undefined}
                height={height}
                width={'100%'}
                pageSettings={pageOptions}
                filterSettings={FilterOptions}
                allowFiltering={true}
                allowPaging={true}
                showColumnMenu={true}
                allowResizing={true}
                allowExcelExport={true}
                allowPdfExport={true}
                allowSorting={true}
                allowReordering={true}
                toolbarTemplate={toolbarTemplate}
                groupSettings={groupSettings}
                showColumnChooser={true}
                allowGrouping={true}
                queryCellInfo={queryCellInfo}
                dataBound={() => {
                    if (isFitInCOntent) {
                        theGridRef.current?.autoFitColumns(theGridRef.current?.getColumnFieldNames());
                    }
                }}
                toolbarClick={
                    toolbarClickItems
                        ? toolbarClickItems.bind(this)
                        : toolbarClick.bind(this)
                }
                actionBegin={actionBegin.bind(this)}
                gridLines='Both'
                rowSelected={rowSelected?.bind(this)}
                rowDeselected={rowDeselected?.bind(this)}
                contextMenuItems={contextMenuItems}
                contextMenuClick={contextMenuClick}
                created={onGridCreated}
                selectionSettings={{
                    type: allowMultiSelection ? 'Multiple' : 'Single',
                    persistSelection: true,
                }}
                allowSelection={true}
                excelQueryCellInfo ={excelQueryCellInfo}
                contextMenuOpen = {contextMenuOpen}
            >
                <ColumnsDirective>
                    {allowCheckBox ? (
                        <ColumnDirective
                            headerText='#'
                            allowEditing={false}
                            displayAsCheckBox={true}
                            type='checkbox'
                            width={40}
                        />
                    ) : null}
                    {columns.map((el) => {
                        return (
                            <ColumnDirective
                                field={el.field}
                                headerText={el.headerText?.replaceAll('_', ' ')}
                                textAlign='Left'
                                validationRules={el.validationRule}
                                template={el.template}
                                isPrimaryKey={el.isPrimaryKey}
                                width={el.width}
                                editType={el.editType}
                                allowEditing={el.allowEditing}
                                editTemplate={el.editTemplate}
                                format={el.format}
                                key={el.field}
                                visible={el.visible}
                                clipMode={el.clipMode}
                                type={el.type}
                                edit={el.edit}
                                valueAccessor={el.valueAccessor}
                            />
                        );
                    })}
                </ColumnsDirective>
                {enableAggregate ? (
                    <AggregatesDirective>
                        <AggregateDirective>
                            <AggregateColumnsDirective>
                                {aggregateColumns?.map((col) => {
                                    return (
                                        <AggregateColumnDirective
                                            field={col.field}
                                            type='Sum'
                                            format='C2'
                                            key={col.field}
                                        />
                                    );
                                })}
                            </AggregateColumnsDirective>
                        </AggregateDirective>
                    </AggregatesDirective>
                ) : null}
                <Inject
                    services={[
                        Edit,
                        Toolbar,
                        Filter,
                        Page,
                        ColumnChooser,
                        ExcelExport,
                        PdfExport,
                        ColumnMenu,
                        Resize,
                        Sort,
                        Group,
                        Reorder,
                        Aggregate,
                        ContextMenu,
                        ...(undo ? [UndoRedo] : []),
                    ]}
                />
            </GridComponent>
            <TooltipComponent
                target=".order-code-cell"
                position="TopCenter"
                opensOn="Hover"
                showTipPointer={true}
                cssClass="custom-syncfusion-tooltip"
            />
        </div>
    );
};

export default GlobalGrid;